export default "__VITE_ASSET__CzdO5Sru__"